/**
 * User-facing "my curriculum tree" — the subset of the curriculum tree
 * that contains nodes the user has classified steps for (via their
 * personal lessons). Used for revision-topic selection and testing
 * adaptive zoom.
 */
import { z } from 'zod';
/**
 * Flat list of nodes. Parent-child relationships via parent_id; the
 * frontend builds the tree from this list. Only nodes that are on an
 * ancestor path of a classified-to node are returned, so this is already
 * scoped to the user's accessible material.
 */
export const MyCurriculumTreeNodeSchema = z.object({
    id: z.string().uuid(),
    slug: z.string(),
    displayName: z.string(),
    /** null for roots */
    parentId: z.string().uuid().nullable(),
    depth: z.number().int(),
    /** Distinct step_versions mapped directly to this node. */
    directCount: z.number().int(),
    /** Distinct step_versions mapped anywhere in this node's subtree (incl. itself). */
    subtreeCount: z.number().int(),
});
export const MyCurriculumTreeResponseSchema = z.object({
    nodes: z.array(MyCurriculumTreeNodeSchema),
    /** Total distinct step_versions the user has. */
    totalSteps: z.number().int(),
    /** Generation timestamp (ISO string). Useful for debugging cache behaviour. */
    generatedAt: z.string(),
});
//# sourceMappingURL=my-curriculum-tree.schema.js.map